<template>
    <div class="photo-item">
        <div class="photo-main" @click="handleClick(data)" :class="{ active: data.id == activeId }">
            <img class="photo-box" :src="data.thumbnailUrl" />
            <div class="photo-title">
                <div class="photo-name" :title="data.name">
                    <div class="photo-val"> {{ data.name }}</div> <i class="iconfont icon-dingwei item-icon"></i>
                </div>
                <div class="photo-txt" :title="data.shootingTime">
                    <span class="colc7">{{ $t('hezhang.index.leftAside.photograph')}}：</span>
                    {{ data.shootingTime }}
                </div>
                <div class="photo-txt" :title="data.taskName">
                    <span class="colc7">{{ $t('hezhang.index.leftAside.serviceName')}}：</span>
                    {{ data.taskName }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PictureItem',
    props: {
        data: Object,
        activeId: String,
    },

    data () {
        return {};
    },
    watch: {
        data (newVal) { },
    },

    methods: {
        getphotoDataByid (id, index) {
            this.$emit('clickActiveId', id);
        },
        handleClick () {
            this.$emit('click', this.data);
        },
    },
};
</script>

<style lang="scss" scoped>
* {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
}

/* 照片项容器 */
.photo-item {
    width: 100%;
}

/* 单个照片项样式 */
.photo-main {
    padding: 16px 0;
    border-bottom: 1px solid #1a47a4;
    position: relative;
    cursor: pointer;
    transition: background-color 0.2s;
}

/* 激活状态样式 */
.photo-main.active {
    background-color: #1a47a480;
}

/* 照片缩略图 */
.photo-box {
    display: inline-block;
    vertical-align: top;
    width: 80px;
    height: 60px;
    padding-left: 4px;
    object-fit: cover;
    /* 确保图片填充容器 */
}

/* 照片信息容器 */
.photo-title {
    position: relative;
    left: 10px;
    display: inline-block;
    width: calc(100% - 90px);
    /* 减去缩略图以及照片与文字的宽度 */

}

/* 照片名称 */
.photo-name {
    font-size: 16px;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-bottom: 4px;
    display: flex;

    .photo-val {

        width: 90%;
        overflow: hidden;
        text-overflow: ellipsis;

        i {
            display: inline-block;
        }
    }
}

/* 照片详情信息 */
.photo-txt {
    font-size: 14px;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.4;
    .colc7{
        color: #c7c7c7;
    }
}
</style>
